import React from "react";
import styles from "./index.module.css";
import SoldOutImg from '../../assets/images/Sold-out-02.png';

const SoldOut = () => {
  return (
    <div className={styles.noResults}>
      <img
        src={SoldOutImg}
        alt="No Results Found"
        className={styles.noResultsImage}
      />
    </div>
  );
};

export default SoldOut;
